export default __webpack_public_path__ + "static/media/bottomspawn.cff1446d.svg";